import { IStoreFields } from 'Shared/forms/Inputs';
import {createContext,JSX,useContext} from 'solid-js';

const StoreContext = createContext();

export function StoreProvider<D>(props:IStoreFields<D> & {children:JSX.Element})
{
	return (
		<StoreContext.Provider value={props}>
			{props.children}
		</StoreContext.Provider>
	);
}

export function useStore<D>():IStoreFields<D> 
{
	return useContext(StoreContext);
}

